import { render, staticRenderFns } from "./SizeModifier.vue?vue&type=template&id=7c7119e4&"
import script from "./SizeModifier.vue?vue&type=script&lang=js&"
export * from "./SizeModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports